import MountainsIcon from '@repo/ui/src/components/Icons/MountainsIcon';
import { classNames } from '@repo/ui/src/utils/classNames';
import React, { useId } from 'react';

interface LoadingLogoProps {
  className?: string;
  svgClassName?: string;
  small?: boolean;
  xSmall?: boolean;
}
const LoadingLogo = ({ className, svgClassName, small }: LoadingLogoProps) => (
  <span
    data-testid="loading-logo"
    className={classNames('grid place-content-center h-full text-warm-200', className)}
  >
    <MountainsIcon
      className={classNames(svgClassName, small ? 'h-7' : 'max-w-lg w-full')}
      disableSize
      shimmer={{
        id: `shimmer_${useId()}`,
        highlightColor: 'var(--tra-color-warm-300)',
      }}
    />
  </span>
);

export default LoadingLogo;
